import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <section id="services" className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="overline text-concrete-500">/ What we pour</span>
            <h2 className="mt-4 font-display font-extrabold tracking-tighter text-concrete-900 text-5xl sm:text-6xl leading-[0.95]">
              Services
            </h2>
          </div>
          <p className="max-w-sm text-concrete-600 text-base leading-relaxed">
            Residential concreting done properly — from a single slab to a full backyard transformation across Sydney.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-black/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.08}>
              <a
                href="#contact"
                data-testid={`service-card-${s.id}`}
                className="group relative flex flex-col h-full border-r border-b border-black/10 bg-background overflow-hidden"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={s.img}
                    alt={`${s.title} by Upscale Concrete Services`}
                    className="h-full w-full object-cover scale-105 group-hover:scale-110 transition-transform duration-700"
                  />
                  <span className="absolute top-3 left-3 font-mono text-xs bg-background/90 px-2 py-1 text-concrete-900">
                    {s.no}
                  </span>
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-display font-bold text-2xl tracking-tight text-concrete-900">{s.title}</h3>
                    <ArrowUpRight className="h-5 w-5 text-concrete-400 group-hover:text-concrete-900 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0 mt-1" />
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-concrete-600">{s.desc}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
